/**
 * The same route tree with the named routes taken out, at any depth.
 *
 * A route that is not in the tree has no path to match and no key for
 * usePermissionTabs to resolve, so both the screen and the tab that leads to it
 * disappear — which is what holding a feature back needs.
 *
 * @param {Array} routes route tree, each entry optionally carrying `routes`
 * @param {string[]} keys the `key` values to leave out
 */
const withoutRouteKeys = (routes, keys) => {
  if (!keys.length) return routes;

  return routes
    .filter((route) => !keys.includes(route.key))
    .map((route) =>
      route.routes ? { ...route, routes: withoutRouteKeys(route.routes, keys) } : route,
    );
};

export default withoutRouteKeys;
